import api from "shared/api";

const prefix = "api/appointments";

export type Appointment = {
  project_description: string;
  task_description: string;
  plan_date: string;
  duration: number;
  executors: string;
  note: string;
};

export const getAll = async (): Promise<Appointment[]> => {
  const res = await api().get<Appointment[]>(`${prefix}/current-user`);
  return res.data;
};
